import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'skull-loader',
    template: `
        <ngx-skeleton-loader
            class="w-full h-full"
            [theme]="{
                'border-radius': '2px',
                width: '100%',
                height: '100%',
                'margin-bottom': '0px',
                display: 'flex',
                'align-items': 'center',
                'justify-content': 'center',
                background: bgColor
            }"
        ></ngx-skeleton-loader>
    `,
})
export class LoaderComponent implements OnInit {
    @Input() bgColor: any = '#E7E7EE';
    constructor() {}

    ngOnInit() {}
}
